import React, { createContext, useContext, ReactNode } from 'react';

interface TabContextProps {
  activeTab: string;
}

const TabContext = createContext<TabContextProps | undefined>(undefined);

interface TabProviderProps {
  active: string;
  children: ReactNode;
}

export const TabProvider = ({ children, active }: TabProviderProps) => {
  return (
    <TabContext.Provider value={{ activeTab: active }}>
      {children}
    </TabContext.Provider>
  );
};

export const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext must be used within a TabProvider');
  }
  return context;
};

interface TabContentProps {
  id: string;
  children: React.ReactNode;
}

export const TabContent = ({ id, children }: TabContentProps) => {
  const { activeTab } = useTabContext();

  if (activeTab !== id) {
    return null;
  }

  return <>{children}</>;
};
